import { createContext } from 'react';
const AnnotationContext = /*#__PURE__*/createContext({});
export default AnnotationContext;